import React, { useState } from 'react';
import { getApi } from '../../api/endpoints.js';
import { toast } from "react-toastify";

import Page from "../Page.js";
import FormPartial from "./FormPartial.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import AssetEarningConfig from '../../models/AssetEarningsConfig.js';

const Index = () => {
    const [assetEarningConfig, setAssetEarningConfig] = useState(new AssetEarningConfig());
    const [reset, setReset] = useState(false);
    const [createApi] = getApi('createRentalEarningConfig');
		let assetEarningConfigObj = new AssetEarningConfig();

    const createRecord = async (params) => {
        try {
          await createApi(params).unwrap();
          toast.success("Successfully Added New Configuration.");
          setAssetEarningConfig(new AssetEarningConfig());
          setReset(!reset);
        } catch (error) {
					assetEarningConfigObj.set_api_errors(error.data.errors);
        }
    }

    const onCreateClick = () => {
			try{
				createRecord(new AssetEarningConfig(assetEarningConfig).toApiJson());
			} catch(error){
				setAssetEarningConfig(new AssetEarningConfig(assetEarningConfig));
			}
    }

    return <Page
        uiPage={uiManager.getUiPage(PAGES.AssetEarningsConfigPage.name)}
        breadcrumbs={[{ label: "Home", url: '/dashboard'}, { label: "Add Rental Earnings Config" }]}
        className={'add-Rental-Earnings-Config-page'}
    >
      <PageContentWrapper contentHeading={"Rental Earnings Configuration"}>
        <div className='m-3'>
          <form className="row g-4" autoComplete="off" onKeyDown={e => e.key === 'Enter' && e.preventDefault()}>
            <FormPartial assetEarningConfig={assetEarningConfig} setAssetEarningConfig={setAssetEarningConfig} reset={reset}/>
            <div className='mb-4 col-md-12'>
              <div>
                <button type="button" className="btn btn-voltup-theme" onClick={onCreateClick}>
                  Create New Configuration
                </button>
              </div>
            </div>
          </form>
        </div>
      </PageContentWrapper>
    </Page>
};

export default Index;
